import useTranslation from 'next-translate/useTranslation';
import { useMemo } from 'react';
import { formatDateDistanceByLocale } from './utils/formatDateDistanceByLocale';

export interface ITextDateProps {
  dateTextWithTimezone?: string;
  locale?: string;
}

const TextDate = ({ dateTextWithTimezone, locale = 'en-US' }: ITextDateProps) => {
  const { t } = useTranslation('common');

  const dateFormatted = useMemo(() => {
    const dateFormatted = formatDateDistanceByLocale({
      dateTextWithTimezone,
      locale,
    });
    return dateFormatted ? dateFormatted : t('date_unavailable');
  }, [dateTextWithTimezone, locale, t]);

  return <>{dateFormatted}</>;
};

export default TextDate;
